import { modelsCompFn } from '@/lib/filter/base-frontend-filter/scope';

export const directPlanningsFn = ({ entity, scope }) => {
  const models = entity[scope.directProperty.edgeName];
  const neededModels = scope.plannings;
  return modelsCompFn({ models, neededModels, isEmpty: scope.isEmpty });
};
